export enum RodzajPolaTowarowego {
  lokalizacja,
  indeks,
  ilosc,
}
